// extracted by mini-css-extract-plugin
module.exports = {"teaserContainer":"document-teaser-block-module--teaserContainer--223JX"};